export default __webpack_public_path__ + "images/4d0c50eb3fb806f8764f6adc492c91ec.svg";